/*eslint no-unreachable: "off"*/
/*eslint no-useless-concat: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint no-unused-vars: "off"*/
export function insertComma(n) {
  var reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n))
    n = n.replace(reg, '$1' + "," + '$2');
  return n;
}

function chartColor(displayName) {
  if (displayName.indexOf('2톤 미만') !== -1) return "#4452a8";
  else if (displayName.indexOf('2~5톤 이하') !== -1) return "#fabc05";
  else if (displayName.indexOf('5~40톤 이하') !== -1) return "#5587a2";
  else if (displayName.indexOf('40~100톤 이하') !== -1) return "#69cabc";
  else if (displayName.indexOf('100톤 초과') !== -1) return "#6c4a85";
  else if (displayName.indexOf('연해') !== -1) return "#4452a8";
  else if (displayName.indexOf('근해') !== -1) return "#fabc05";
  else if (displayName.indexOf('평수지역') !== -1) return "#5587a2";
  else if (displayName.indexOf('원양') !== -1) return "#69cabc";
  else if (displayName.indexOf('기타') !== -1) return "#6c4a85";
  else if (displayName.indexOf('어선') !== -1) return "#4452a8";
  else if (displayName.indexOf('화물선') !== -1) return "#fabc05";
  else if (displayName.indexOf('여객선') !== -1) return "#5587a2";
  else if (displayName.indexOf('기타') !== -1) return "#69cabc";
  else return "#cccccc";
}

export function dataReturnByDataType(dataList) {
  let chart2List = []; // 항해구역별 현황
  let chart3List = []; // 톤수별 현황
  let chart4List = []; // 선종별 현황

  for (let i = 0; i < dataList.length; ++i) {
    let item = dataList[i];
    switch (item.DATA_TYPE) {
      case 'DATA_TYPE1' : // 항해구역별 현황
        chart2List.push(item);
        break;
      case 'DATA_TYPE2' : // 톤수별 현황
        chart3List.push(item);
        break;
      case 'DATA_TYPE3' : // 선종별
        chart4List.push(item);
        break;
      // no default
    }
  }
  return {chart2List, chart3List, chart4List};
}

/**
 title: "지역별 선박국 무선국 수",
 xtitle: "무선국 수",
 ytitle: "지역명",
 chartType: "Multi Series Stacked Bar",
 layOutStyle: "Detail",
 masterName: "무선국 수",
 valueFixed: 0,
 */
export function layoutForChart1(chartLayoutProps, {
  cmb_gubun_chart, searchYear,
  prm_check, prm_check_label, prm_check2, prm_check2_label, prm_check3, prm_check3_label
}) {

  let layOutData;

  let titleData = "";
  if (cmb_gubun_chart === "01") {
    titleData = "톤수별 ";
  } else if (cmb_gubun_chart === "02") {
    titleData = "항해구역별 ";
  } else if (cmb_gubun_chart === "03") {
    titleData = "선종별 ";
  }

  let dataTipJsFunctionData = "";
  if (chartLayoutProps.valueFixed > 0) {
    if (chartLayoutProps.layOutStyle === 'Mater') {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc2_stacked_bar"';
    }
  } else {
    if (chartLayoutProps.layOutStyle === 'Mater') {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0"';
    } else {
      dataTipJsFunctionData = ' dataTipJsFunction="dataTipFunc0_stacked_bar"';
    }
  }

  layOutData =
    '<rMateChart backgroundColor="#FFFFFF" borderStyle="none" >'
    + '<Options>'
    + '<Caption fontSize="19" text="' + titleData + chartLayoutProps.title + '"/>'
    //+'<Caption fontSize="19" text="'+titleData+chartBaseData["chart"+i].title+' &lt;a href=javascript:cartDownload(\'chart'+i+'\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart'+i+'\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt; "/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + searchYear.substr(0, 4) + '년)"/>'
    + '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15"/>'
    + '</Options>'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Bar3DChart showDataTips="true"' + dataTipJsFunctionData + '>'
    + '<horizontalAxis>'
    + '<LinearAxis formatter="{numfmt}" id="hAxis" title="' + chartLayoutProps.xtitle + '" labelJsFunction="labelFuncNum"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    + '<CategoryAxis id="vAxis" categoryField="GUBUN_NM" title="' + chartLayoutProps.ytitle + '" labelJsFunction="labelFunc"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="false" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<series>';
  layOutData +=
    '<Bar3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
    + '<series>';
  // var gubun_chart = window.cmb_gubun_chart;

  if (cmb_gubun_chart === '01') { // 톤수별

    for (let j = 0; j < prm_check.length; j++) {

      if (prm_check[j]) {
        layOutData +=
          '<Bar3DSeries labelPosition="inside" xField="DATA_01_' + prm_check[j] + '_CNT" displayName="' + prm_check_label[j] + '" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check_label[j]) + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Bar3DSeries>';

      }
    }
  } else if (cmb_gubun_chart === '02') { // 항해구역별

    for (let j = 0; j < prm_check2.length; j++) {

      if (prm_check2[j]) {

        layOutData +=
          '<Bar3DSeries labelPosition="inside" xField="DATA_02_' + prm_check2[j] + '_CNT" displayName="' + prm_check2_label[j] + '" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check2_label[j]) + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Bar3DSeries>';


      }

    }
  } else if (cmb_gubun_chart === '03') { // 선종별

    for (let j = 0; j < prm_check3.length; j++) {

      if (prm_check3[j]) {

        layOutData +=
          '<Bar3DSeries labelPosition="inside" xField="DATA_03_' + prm_check3[j] + '_CNT" displayName="' + prm_check3_label[j] + '" styleName="seriesLabel" showValueLabels="[]">'
          + '<fill>'
          + '<SolidColor color="' + chartColor(prm_check3_label[j]) + '"/>'
          + '</fill>'
          + '<showDataEffect>'
          + '<SeriesInterpolate/>'
          + '</showDataEffect>'
          + '</Bar3DSeries>';


      }

    }
  }
  layOutData +=
    '</series>'
    + '</Bar3DSet>';

  layOutData +=
    '</series>'
    + '<annotationElements>'
    + '<CrossRangeZoomer zoomType="vertical"  enableZooming="true" enableCrossHair="false">'
    + '</CrossRangeZoomer>'
    /* CrossRangeZoomer 속성 설명
* zoomType : 줌 실행 기준을 정합니다. 유효값 : horizontal, vertical, both
* horizontalLabelFormatter : 십자가의 수평 라인에 붙는 라벨 formatter 입니다.
* verticalLabelFormatter : 십자가의 수직 라인에 붙는 라벨 formatter 입니다.
* enableZooming : zoom 기능 사용 여부를 나타냅니다.
* enableCrossHair : 십자가 표시 여부를 나타냅니다.
* useDualCrossXLabel : 십자가의 수평 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* useDualCrossYLabel : 십자가의 수직 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* verticalLabelPlacement : 수직 라인의 라벨 위치를 지정합니다.(유효값: top, bottom)
* horizontalLabelPlacement : 수평 라인의 라벨 위치를 지정합니다.(유효값 : left, right)
*/
    + '</annotationElements>'
    + '</Bar3DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';

  return layOutData;
}

export function layoutForPie3DChart(chartLayoutProps, { searchYear, prm_check, prm_check_label }) {
  let layOutData;

  layOutData = '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">'
    + '<Options>'
    + '<Caption fontSize="19" text="' + chartLayoutProps.title + '  "/>'
    //+'<Caption fontSize="19" text="'+chartBaseData["chart"+i].title+' &lt;a href=javascript:cartDownload(\'chart'+i+'\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart'+i+'\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt; "/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + searchYear.substr(0, 4) + '년' + searchYear.substr(4, 2) + '월)"/>'
    //+'<SubCaption text="2012"/>'
    + '<Legend useVisibleCheck="true" fontSize="15"/>'
    + '</Options>'
    + '<NumberFormatter id="numFmt"/>'
    /*
    Pie3D 차트 생성시에 필요한 Pie3DChart 정의합니다
    showDataTips : 데이터에 마우스를 가져갔을 때 나오는 Tip을 보이기/안보이기 속성입니다.
     */
    //+'<Pie2DChart showDataTips="true" color="#000000" fontWeight="bold" fontSize="13">'	//파이차트 내부 글씩 색상 변경시 사용법
    + '<Pie2DChart showDataTips="true">'
    + '<series>'
    + '<Pie2DSeries nameField="DATA_FIELD" field="DATA_CNT" labelPosition="insideWithCallout" labelYOffset="-2" labelXOffset="0" color="#000000" fontWeight="bold" fontSize="14">';
  /* Pie3DChart 정의 후 Pie3DSeries labelPosition="inside"정의합니다 */
  layOutData += '<fills>';

  // prm_check, prm_check2, prm_check3이 있음. 인자로 넘겨주면 됨.
  for (let j = 0; j < prm_check.length; j++) {
    if (prm_check[j]) {
      layOutData += '<SolidColor color="' + chartColor(prm_check_label[j]) + '"/>'
    }
  }

  layOutData += '</fills>';
  layOutData += '<showDataEffect>'
    /* 차트 생성시에 Effect를 주고 싶을 때 shoDataEffect정의합니다 */
    + '<SeriesInterpolate duration="1000"/>'
    /*
  SeriesInterpolate 효과는 시리즈 데이터가 데이터로 표시될 때 데이터의 변화된 내용을 가지고 효과를 적용합니다
     - 공통 -
     elementOffset : effect를 지연시키는 시간을 지정합니다 default:20
   minimumElementDuration : 각 엘리먼트의 최소 지속 시간을 설정합니다 default:0
                이 값보다 짧은 시간에 effect가 실행되지 않습니다
  offset : effect개시의 지연시간을 설정합니다 default:0
     perElementOffset : 각 엘리먼트의 개시 지연시간을 설정합니다
    */
    + '</showDataEffect>'
    + '</Pie2DSeries>'
    + '</series>'
    + '</Pie2DChart>'
    + '</rMateChart>';
  return layOutData;
}

window.labelFunc = function (index, value) {
  return '<font size="15">' + value + '</font>';
  return "";
};
window.labelFunc2 = function (index, value) {
  return '<font size="13">' + value + '</font>';
  return "";
};
window.labelFuncNum = function (index, value) {
  return '<font size="15">' + window.insertComma(value) + '</font>';
  return "";
};

window.totalFunc = function (index, data, value) {
  if (index === 3)
    return window.insertComma(value);
  return "";
};

//숫자에 천단위 콤마 찍어 반환하는 함수.
window.insertComma = function (n) {
  var reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n))
    n = n.replace(reg, '$1' + "," + '$2');
  return n;
};


window.dataTipFunc0 = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b> : " + window.insertComma(Number(values[1])) + "</font>";

};

window.dataTipFunc2 = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><font style='font-size:15px;'><b>" + values[0] + "</b> : " + window.insertComma(Number(values[1]).toFixed(2)) + "</font>";
};

window.dataTipFunc0_stacked = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b>"
    + "<br/>" + seriesName + " : " + window.insertComma(Number(values[1])) + "</font>";

};

window.dataTipFunc2_stacked = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'><b>" + values[0] + "</b>"
    + "<br/>" + seriesName + " : " + window.insertComma(Number(values[1]).toFixed(2)) + "</font>";

};

window.dataTipFunc2_Pie = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<font style='font-size:15px;'>" + data.DATA_FIELD + " : <b>" + data.DATA_SUM_str
    + ", " + window.insertComma(Number(values[1]).toFixed(2)) + "%</b>" + "</font>";
};

window.dataTipFunc0_stacked_bar = function (seriesId, seriesName, index, xName, yName, data, values) {
return "<font style=\"font-size:15px;\"><b>" + values[1] + "</b>"
    + "<br/>" + seriesName + " : " + insertComma(Number(values[0])) + "</font>";

};

window.dataTipFunc2_stacked_bar = function (seriesId, seriesName, index, xName, yName, data, values) {
  return "<b>" + values[1] + "</b>"
    + "<br/>" + seriesName + " : " + insertComma(Number(values[0]).toFixed(2)) + " %";

};